import axios from "axios";
import { CareerListModel } from "../entities/CareerListModel";
import { CareerItemModel } from "../entities/CareerItemModel";
import { CareerTypeModel } from "../entities/CareerTypeModel";
import { CareerEducationModel } from "../entities/CareerEducationModel";
import { CareerMetaModel } from "../entities/CareerMetaModel";

const API_URL = `${process.env.REACT_APP_API_URL}careers`;

export const fetchCareer = async (): Promise<CareerListModel> => {
    try {
        const response = await axios.get(API_URL);
        
        // First, we need to map each career item in the array to a CareerItemModel
        const careerItems = response.data.data.map((item: any) => {
            // Create instances of nested models first
            const typeModel = new CareerTypeModel(
                item.type.code,
                item.type.name
            );
            
            const educationModel = new CareerEducationModel(
                item.education_level.code,
                item.education_level.name
            );

            // Create the meta model instance
            const metaModel = new CareerMetaModel(
                item.meta.is_active,
                item.meta.published_at,
                item.meta.created_at,
                item.meta.updated_at
            );
            
            // Create the CareerItemModel with all required parameters
            return new CareerItemModel(
                item.id,
                item.title,
                item.slug,
                item.description,
                typeModel,
                educationModel,
                item.location,
                item.image_url,
                item.job_requirements,
                item.job_description,
                metaModel,
                item.share_url
            );
        });
        
        // Finally, create and return the CareerListModel with the array of CareerItemModel
        return new CareerListModel(careerItems);
        
    } catch (error) {
        console.error('Error fetching careers:', error);
        throw new Error('Failed to fetch career data: ' + (error as Error).message);
    }
}